import React from 'react'
import {SingleValueTooltip} from 'react-stockcharts/lib/tooltip'
import BollingerBandTooltip from './BollingerBandTooltip'
import MACDTooltip from './MACDTooltip'
import {schemeCategory10} from 'd3-scale'
import {format} from 'd3-format'

export const Tooltip = (props) => {
  const {indicator, index} = props
  const {syntax} = indicator
  let label = indicator.ident
  if (label.indexOf('_') !== -1) {
    label = label.split('_').map(word => word.slice(0,1) + word.slice(1).toLowerCase()).join(' ')
  }
  if (syntax === 'ema' || syntax === 'ma') {
    const windowSize = indicator.params.NUM_DAYS || indicator.options.find(option => option.ident === 'NUM_DAYS').default_value
    if (windowSize) {
      label = `${label} (${windowSize})`
    }
  }

  if (indicator.ident === 'BB') {
    return(
      <Buttons {...props} isBB={true}>
        <BollingerBandTooltip
          origin={[0,0]}
          yAccessor={d => d.bb}
          fontSize={15}
          fontFamily='GothamHTF'
          labelFill='rgb(164, 164, 164)'
          textFill='rgb(70, 70, 70)'
        />
      </Buttons>
    )
  }

  if (indicator.ident === 'MACD') {
    return(
      <Buttons {...props}>
        <MACDTooltip
          origin={[0,0]}
          yAccessor={d => d.macd}
          options={{}}
          appearance={macdAppearance}
          fontSize={15}
          fontFamily='GothamHTF'
          labelFill='rgb(164, 164, 164)'
        />
      </Buttons>
    )
  }

  return(
    <Buttons {...props}>
      <SingleValueTooltip
        yAccessor={d => d[syntax]}
        yLabel={label}
        yDisplayFormat={format('.2f')}
        origin={[0,0]}
        valueFill={indicator.separate ? 'rgb(70, 70, 70)' : schemeCategory10[index]}
        fontSize={15}
        fontFamily='GothamHTF'
        labelFill='rgb(164, 164, 164)'
      />
    </Buttons>
  )
}

const getOrigins = ({separate, index, gridWidth, marginTop, isBB}) => {
  if (separate) {
    return({originX: -55, originY: -12})
  }

  const rowSize = Math.floor(gridWidth/320)
  let rowIndex = Math.floor(index/rowSize)
  let colIndex = index%rowSize

  if (isBB && colIndex !== 0) {
    rowIndex++
    colIndex = 0
  }

  const originX = -55 + 320*colIndex
  const originY = -marginTop + 80 + 35*rowIndex

  return {originX, originY}
}

const Buttons = ({indicator, showModal, gridWidth, marginTop, index, children, isBB}) => {
  const {separate} = indicator
  const {originX, originY} = getOrigins({separate, index, gridWidth, marginTop, isBB})

  let buttonsOffset = 240
  if (indicator.separate) {
    buttonsOffset = gridWidth + 23
  }
  if (isBB) {
    buttonsOffset = 480
  }

  return(
    <g transform={`translate(${originX},${originY})`}>
      <g transform='translate(0, 0)' id='test'>
        {children}
      </g>
      <g
        transform={`translate(${buttonsOffset - 69}, -12)`}
        style={{pointerEvents: 'bounding-box', cursor: 'pointer'}}
        onClick={() => showModal(indicator)}
      >
        <path
          fillRule='evenodd'
          fill='rgb(182, 182, 182)'
          stroke='none'
          d='M13.799,5.786 L13.395,4.867 C13.395,4.867 14.334,2.839 14.251,2.761 L13.007,1.599 C12.921,1.519 10.801,2.445 10.801,2.445 L9.823,2.067 C9.823,2.067 8.959,0.011 8.840,0.011 L7.085,0.011 C6.962,0.011 6.163,2.071 6.163,2.071 L5.186,2.450 C5.186,2.450 3.021,1.570 2.938,1.649 L1.696,2.812 C1.610,2.892 2.599,4.880 2.599,4.880 L2.195,5.796 C2.195,5.796 0.000,6.605 0.000,6.714 L0.000,8.361 C0.000,8.476 2.200,9.225 2.200,9.225 L2.604,10.140 C2.604,10.140 1.665,12.167 1.747,12.245 L2.990,13.410 C3.075,13.489 5.196,12.563 5.196,12.563 L6.175,12.942 C6.175,12.942 7.039,14.997 7.158,14.997 L8.913,14.997 C9.035,14.997 9.835,12.937 9.835,12.937 L10.815,12.557 C10.815,12.557 12.975,13.438 13.059,13.361 L14.302,12.197 C14.389,12.116 13.398,10.130 13.398,10.130 L13.801,9.213 C13.801,9.213 15.997,8.403 15.997,8.292 L15.997,6.647 C15.998,6.533 13.799,5.786 13.799,5.786 ZM10.563,7.504 C10.563,8.827 9.413,9.905 7.999,9.905 C6.587,9.905 5.435,8.827 5.435,7.504 C5.435,6.180 6.587,5.104 7.999,5.104 C9.414,5.104 10.563,6.180 10.563,7.504 Z'
        />
      </g>
      <g
        transform={`translate(${buttonsOffset}, -12)`}
        style={{pointerEvents: 'bounding-box', cursor: 'pointer'}}
        onClick={indicator.remove}
      >
        <path
          fillRule='evenodd'
          fill='rgb(220, 91, 66)'
          stroke='none'
          d='M6.545,5.533 L11.561,0.505 L13.006,1.953 L7.990,6.981 L13.006,12.009 L11.561,13.456 L6.545,8.429 L1.529,13.456 L0.085,12.009 L5.101,6.981 L0.085,1.953 L1.529,0.505 L6.545,5.533 Z'
        />
      </g>
    </g>
  )
}

const macdAppearance = {
  stroke: {
    macd: '#FF0000',
    signal: '#00F300',
  },
  fill: {
    divergence: '#4682B4'
  }
}
